export default "__VITE_ASSET__4ebc3fe0__"